import { Language, SupportedMarketKey } from '@nxt-insurance/constants'

export type FooterLinkData = {
  link: string | Record<Language, string>
  label: string
}

const footerLegalLinksCommon: FooterLinkData[] = [
  {
    link: `/impressum`,
    label: 'flows.footer.legalNotice',
  },
  {
    link: `/documents/erstinformationen.pdf`,
    label: 'flows.footer.initialInformation',
  },
  {
    link: `/documents/datenschutzhinweis.pdf`,
    label: 'flows.footer.dataProtection',
  },
  {
    link: {
      [Language.En]: `/documents/agb_en.pdf`,
      [Language.De]: `/documents/agb_de.pdf`,
    },
    label: 'flows.footer.termsOfUse',
  },
]

export const marketFooterLegalLinks: Record<SupportedMarketKey, FooterLinkData[]> = {
  [SupportedMarketKey.De]: footerLegalLinksCommon,
  [SupportedMarketKey.At]: footerLegalLinksCommon,
}

export const MAX_FLOWS_WIDTH = 560
